<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Confirm',
    },
    message: {
      type: String,
      required: true,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    confirm() {
      this.$emit('confirm')
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<template>
  <v-dialog
    :value="dialog"
    :max-width="300"
    persistent
    :content-class="$style.dialogContainer"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-toolbar color="primary" dense flat>
        <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!message" class="pa-4"
        ><h5 :class="$style.confirmText">{{ message }}</h5></v-card-text
      >
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click.native="confirm">{{
          $t('yes')
        }}</v-btn>
        <v-btn color="grey" text @click.native="cancel">{{
          $t('cancel')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
.dialogContainer {
  border-radius: 16px !important;
}
// truncate after 3 lines
.confirmText {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
}
</style>
